import React from 'react';
import MegaMenu from '../MegaMenu/MegaMenu';
import clsx from 'clsx';

const NavigationLink = ({
  link,
  isActive,
  onMegaMenuClose,
  blocks,
  onLinkClick,
  right = false,
}) => (
  <>
    {link.links?.length > 0 || blocks.length > 0 ? (
      <>
        <button
          className={clsx(
            'flex',
            'items-center',
            'font-garamond',
            'h-full',
            'text-lg',
            'text-gray-900',
            'no-underline',
            'group-[.is-light-theme]:text-white',
            'relative',
            'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-gray-700 after:opacity-0 after:transition after:duration-1000 after:ease-in-out after:content-[""] group-[.is-light-theme]:after:bg-white',
            'hover:after:opacity-100',
            isActive && 'after:opacity-100'
          )}
          onClick={onLinkClick}
        >
          {link.name}
        </button>
        <MegaMenu
          onMegaMenuClose={onMegaMenuClose}
          link={link}
          open={isActive}
          blocks={blocks}
        />
      </>
    ) : (
      <a
        className={clsx(
          'flex',
          'items-center',
          'font-garamond',
          'h-full',
          'text-lg',
          'text-gray-900',
          'no-underline',
          'group-[.is-light-theme]:text-white',
          'relative',
          'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-gray-700 after:opacity-0 after:transition after:duration-1000 after:ease-in-out after:content-[""] group-[.is-light-theme]:after:bg-white',
          'hover:after:opacity-100'
        )}
        href={link.url}
      >
        {link.name}
      </a>
    )}
  </>
);

export default NavigationLink;
